module.exports = __webpack_public_path__ + "static/media/canada character.ddf4e349.gif";